// src/components/SkillsCard.tsx
import React from "react";

interface SkillsCardProps {
  idx: number;
  title: string;
  items: string[];
}

export const SkillsCard: React.FC<SkillsCardProps> = ({
  idx,
  title,
  items,
}) => {
  return (
    <div
      key={idx}
      className="bg-white rounded-xl shadow-lg flex flex-col flex-1 min-w-[250px] border border-gray-200"
    >
      <div className="bg-white p-3 rounded-t-xl z-1 shadow">
        <h3 className="text-lg text-center font-bold text-teal-800">{title}</h3>
      </div>

      <div className="overflow-y-auto p-6 scrollbar-custom">
        <ul className="space-y-1">
          {items.map((item, i) => (
            <li key={i} className="flex items-center text-gray-700">
              <span className="h-1.5 w-1.5 bg-teal-500 rounded-full mr-2.5 flex-shrink-0"></span>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
